module.exports = __webpack_public_path__ + "static/media/stijn-bessem-icon-triangle-right.a618475e.svg";